try {

    window.moment = require('moment/moment');
    window.moment.locale('fr');
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = window.jquery = require('jquery');
    window.Swal = require('sweetalert2');
    window.axios =require('axios');
    window.axios.defaults.headers.common['X-Requested-with'] = 'XMLHttpRequest';
    window.tus = require('tus-js-client');
    window.intlTelInput = require('intl-tel-input/build/js/intlTelInput.min');
    window.impersonateStudent = require('./impersonate').student;
    window.impersonateTeacher = require('./impersonate').teacher;
    window.removeProfilePicture = require('./helpers').removeProfilePicture;
    window.showProfilePicturePreview = require('./helpers').showProfilePicturePreview;
    window.copyDatesToAllGroups = require('./admin/library').copyDatesToAllGroups;
    require('jquery-ui/ui/effect');
    require('jquery-ui/ui/widgets/sortable');
    require('moment/locale/fr');
    require('overlayscrollbars');
    require('../../public/vendor/adminlte/dist/js/adminlte');
    require('datatables.net');
    require('datatables.net-responsive-bs')
    require('datatables.net-bs4');
    require('datatables.net-rowreorder/js/dataTables.rowReorder.min');
    require('datatables.net-buttons-bs4');
    require('datatables.net-buttons/js/buttons.colVis.min');
    require('../../resources/js/vendor/datatables/buttons.server-side.js');
    require('laravel-datatables-assets')
    require('bootstrap');
    require('select2/dist/js/select2.full.min');
    require('select2/dist/js/i18n/fr');
    require('daterangepicker');
    require('bootstrap4-datetimepicker');
    require('bootstrap-duallistbox/dist/jquery.bootstrap-duallistbox');
    require('bootstrap-switch');
    require('bootstrap-maxlength');
    require('chart.js/dist/chart')
    require('summernote/dist/summernote-bs4');
    require('summernote/dist/lang/summernote-fr-FR');
    require('@dsvllc/summernote-image-attributes');
    require('@dsvllc/summernote-image-attributes/lang/fr-FR');
    require('./grideditor');
    require('@frontwise/grid-editor/src/js/jquery.grideditor.summernote');
    require('./fontawesome-iconpicker');
    require('jquery-validation');
    require('./forms-validation')
    require('./publication-daterangepicker');
    require('./dropdown-toggle');
    require('./events/events');
    require('./events/create-events-dates');
    require('./events/edit-events-dates');
    require('./icon-picker');
    require('./pedagogical_space');
    require('./billing-profiles/billing-profile.js');
    require('./video-upload');
    require('passwordruleshelper/dist/js/passwordRulesHelper');
    require('./www/funnel');
    require('./www/form-validation');
    require('./linkedSelect');
    require('./oav');
    require('./sweet-alert-2');
    require('./article-media-blocks');
    require('./summernote-tables-styles');
    require('./summernote-templates/summernote-templates');
    require('./summernote-tables-headers');
    require('./helpers').webMHelperInfo();
    require('./admin/ecommerce/orders');
    require('./admin/ecommerce/products-form');
    require('./admin/livestream/create-form');
    require('./admin/livestream/edit-form');
    require('./admin/oav/manage-modules');
    require('./admin/oav/manage-groups-form');
    require('./admin/oav/offer-form');
    require('./admin/datatables/brand-filter');

} catch (e) {
    console.error(e);
}
